module.exports = __webpack_public_path__ + "static/img/avatar-s-12.cec148fe.png";